// Re-export only. The handler moved to `@jusbrasil-web/core-next/prometheus` so
// `scope:landing-pages` apps can mount the same bridge — NX forbids them from
// depending on `scope:auth`. This file keeps `apps/auth` and every other existing
// importer on their current path.
export { funnelBridgeApiConfig, funnelBridgeHandler } from '@jusbrasil-web/core-next/prometheus'
